<ng-container *transloco="let t">
  <header
    id="public-header"
    class="bg-white w-full h-[80px] flex items-center justify-center max-md:h-auto max-md:min-h-[80px] max-sm:hidden"
  >
    <div
      id="public-header-container"
      class="max-w-[1440px] w-full h-full flex items-center gap-10 px-8 flex-nowrap max-lg:gap-6 max-md:flex-wrap max-md:p-4 max-md:gap-3 max-md:justify-between max-sm:p-3"
    >
      <div id="public-logo-section" class="w-[184px] h-10 flex items-center shrink-0">
        <a id="public-logo-link" href="/" class="w-full h-full flex items-center">
          <img id="public-logo-img" [src]="logo" alt="loanDepot" class="w-full h-full object-contain object-left" />
        </a>
      </div>

      <nav
        id="navigation"
        class="flex items-center gap-6 shrink-0 whitespace-nowrap max-lg:gap-5 max-md:order-3 max-md:w-full max-md:justify-center max-md:gap-4 max-sm:flex-wrap max-sm:gap-3"
      >
        @for (item of navigationItems; track item.href; let i = $index) {
          <a
            [href]="item.href"
            [id]="'nav-link-' + i"
            class="font-general text-base font-medium text-ld-primary capitalize no-underline transition-opacity duration-200 whitespace-nowrap hover:opacity-80 max-lg:text-sm max-md:text-[13px] max-sm:text-xs"
          >
            {{ item.label }}
          </a>
        }
      </nav>

      <div id="phone-sections" class="flex gap-6 shrink-0 ml-auto max-lg:gap-4 max-md:hidden">
        <div id="phone-section-new" class="flex flex-col items-center whitespace-nowrap">
          <span
            id="phone-label-new"
            class="font-general text-xs font-medium text-gray-500 capitalize tracking-wide leading-4 max-lg:text-[10px]"
          >
            {{ t('publicHeaderPhoneNewLoans') }}
          </span>
          <a
            id="phone-number-new"
            [href]="phoneHref"
            class="font-general text-base font-semibold text-ld-primary capitalize no-underline leading-6 transition-opacity duration-200 hover:opacity-80 max-lg:text-sm"
          >
            {{ phoneNumber }}
          </a>
        </div>
        <div id="phone-section-existing" class="flex flex-col items-center whitespace-nowrap">
          <span
            id="phone-label-existing"
            class="font-general text-xs font-medium text-gray-500 capitalize tracking-wide leading-4 max-lg:text-[10px]"
          >
            {{ t('publicHeaderPhoneExistingLoans') }}
          </span>
          <a
            id="phone-number-existing"
            [href]="phoneHref"
            class="font-general text-base font-semibold text-ld-primary capitalize no-underline leading-6 transition-opacity duration-200 hover:opacity-80 max-lg:text-sm"
          >
            {{ phoneNumber }}
          </a>
        </div>
      </div>

      <ld-language-toggle></ld-language-toggle>

      <div id="cta-section" class="flex gap-4 shrink-0 max-md:gap-2 max-md:ml-auto">
        <button
          id="cta-apply"
          class="btn-primary-ld-purple max-md:py-2 max-md:px-4 max-md:text-sm max-sm:py-1.5 max-sm:px-3 max-sm:text-xs"
          (click)="onApplyNow()"
        >
          {{ t('publicHeaderApplyNow') }}
        </button>
        <button
          id="cta-signin"
          class="py-2 px-6 bg-ld-lime rounded-[20px] font-general text-base font-semibold cursor-pointer transition-all duration-200 whitespace-nowrap uppercase text-ld-primary leading-6 hover:opacity-90 hover:-translate-y-px max-md:py-2 max-md:px-4 max-md:text-sm max-sm:py-1.5 max-sm:px-3 max-sm:text-xs"
          (click)="onSignIn()"
        >
          {{ t('commonLabelsSignIn') }}
        </button>
      </div>
    </div>
  </header>
</ng-container>
